import Button from './button';

export default (props) => {
    const { children } = props;

    return <Button { ...props } className="button--view" icon='view'>{ children ? children : 'View' }</Button>
}